import Text from '@/components/UI/Text';

interface ChatTypeLabelProps {
  chatType: string | null | undefined;
}

export default function ChatTypeLabel({ chatType }: ChatTypeLabelProps) {
  const label =
    chatType === 'team'
      ? 'Team'
      : chatType === 'group'
        ? 'Group'
        : chatType === 'dm'
          ? 'Direct'
          : null;

  if (!label) {
    return null;
  }

  return (
    <Text numberOfLines={1} size="xs" variant="typographySecondary">
      {label}
    </Text>
  );
}
